import Vue from 'vue';
import Vuex from 'vuex';
import CustomerModule from '../store/modules/customer-module';

// Vue.use(Vuex)

export default new Vuex.Store({
    state: {

    },
    mutations: {

    },
    actions: {

    },
    modules: {
        CustomerModule
    }
})